import settingsDefault from '../data/settingsDefaults';

// this method creates object with unique key/value pair for each of our preferences items, if user is new and has no preferences yet, settingsDefault will be use to set default values

// Most of the items are mapped as following
//   Unique Key          ||   Value (Object, Array, Boolean)
// (preferenceName): (preferenceValue)

// cases like 'sector' and 'countryRisk' will be treat it defrently since they are store in indivitually and not all as part of the same preference object
//   Unique Key          ||   Value (Object of unique key and Boolen value)
// (preferenceType): { key(preferenceName): value(preferenceValue)}

export default (preferences) => {
  const settings = settingsDefault();
  // try/catch will prevent error when trying to stringify a value that is not an string

  preferences.forEach((element) => {
    try {
      const saveValue = JSON.parse(element.preferenceValue);
      const preferenceName = element.preferenceName;
      const preferenceType = element.preferenceType;

      if (['sector', 'countryRisk'].includes(preferenceType)) {
        return Object.assign(settings[preferenceType], {
          [`${preferenceName}`]: saveValue,
        });
      }
      if (
        settings.hasOwnProperty(preferenceName) &&
        typeof saveValue === 'object'
      ) {
        return Object.assign(settings[preferenceName], saveValue);
      }
      settings[preferenceName] = saveValue;
    } catch (error) {
      return;
    }
  });

  return settings;
};
